/* eslint-disable */

// import { t } from "@superset-ui/core";
import { Dispatch } from "react";
import { buildQueryContext, DataMask, DataMaskStateWithId, Filter, FilterConfiguration, getColumnLabel, NativeFilterType, QueryFormColumn, QueryFormData, QueryObjectFilterClause } from "@superset-ui/core";
import { getChartData } from "packages/superset-ui-core/src/query/api/v1";
import { rgb } from "d3-color";
// import { setFilterConfiguration } from "src/dashboard/actions/nativeFilters";
import { generateFilterId } from "src/dashboard/components/nativeFilters/FiltersConfigModal/utils";
// import { updateDataMask } from "src/dataMask/actions";

import { AxisLabelSortOrder, DrillDownLevelData, RGBAColor } from "./types";
import { LegendOrientation } from "../types";
import { setTempFilter, updateTempFilter } from "src/dashboard/actions/tempFIlters";

export function convertToHexColor(color: RGBAColor): string {
    const { r, g, b } = color;
    return rgb(r, g, b).formatHex();
};

export function getDrillDownQuery(formData: any, currentColumn: QueryFormColumn, levelData: DrillDownLevelData[]): any {
    return {
      ...formData,
      groupby: [currentColumn],
      adhocFilters: levelData.map(level => ({
        clause: "WHERE",
        comparator: [level.filterValue],
        expressionType: "SIMPLE",
        isExtra: false,
        isNew: false,
        operator: "IN",
        operatorId: "IN",
        sqlExpression: null,
        subject: level.filterColumn
      }))
    };
}

export function getDrillDownQueryForBigNumberPopup(formData: any, currentColumn: QueryFormColumn): any {
  const extraFilters = formData?.extraFormData?.filters || [];
  return {
    ...formData,
    groupby: [currentColumn],
    adhoc_filters: formData.adhocFilters,
    extraFilters
  };
}

export function getPopUpDrillDownQuery(
  formData: any, 
  baseColumn: QueryFormColumn,
  columnValue: string,
  popUpGroupBy?: QueryFormColumn[],
  popUpMetrics?: object[]): any 
{
  return {
    ...formData,
    groupby: popUpGroupBy,
    metrics: popUpMetrics,
    query_mode: "aggregate",
    order_by_cols: [],
    adhoc_filters: [
      {
        clause: "WHERE",
        comparator: columnValue,
        expressionType: "SQL",
        isExtra: false,
        isNew: false,
        sqlExpression: `lower(\"${baseColumn}\")='${columnValue.toLowerCase()}'`
      }
    ]
  };
}
  
export function getDrillDownFilters(levelData: DrillDownLevelData[]): QueryObjectFilterClause[] {
    return levelData.map(level => ({
      col: level.filterColumn,
      op: 'IN',
      val: [level.filterValue]
    }));
}

export async function runPopUpDrilldownQuery(queryFormData: any) {
  try {
    const payload = buildQueryContext(queryFormData, baseQueryObject => [
      {
        ...baseQueryObject,
        filters: [
          ...(baseQueryObject.filters ? baseQueryObject.filters : []),
        ]
      },
    ]);
    return await getChartData(payload) as any;
  } catch (ex) {
    console.log(ex);
  }
  return [];
}

export async function runDrillDownQuery(queryFormData: any, filters: QueryObjectFilterClause[]) {
    try {
      const payload = buildQueryContext(queryFormData, baseQueryObject => [
        {
          ...baseQueryObject,
          filters: [
            ...(baseQueryObject.filters ? baseQueryObject.filters : []),
            ...filters
          ]
        },
      ]);
      const res = await getChartData(payload) as any;
      return res.result[0].data;
    } catch (ex) {
      console.log(ex);
    }
    return [];
}

function getFilterConfig (
  formData: QueryFormData, filterId: string, columnName: string, value: any): Filter {
  const dataMask: DataMask = {
    extraFormData: {
      filters: [{
        col: columnName,
        op: 'IN',
        val: [value]
      }]
    },
    filterState: {
      label: value,
      value: [value]
    }
  };
  
  return {
    id: filterId,
    controlValues: {},
    requiredFirst: false,
    name: `${columnName} Filter`,
    filterType: 'filter_select',
    // for now there will only ever be one target
    targets: [{
      column: { name: columnName },
      datasetId: Number(formData.datasource.replace('__table', ''))
    }],
    defaultDataMask: dataMask,
    cascadeParentIds: [],
    scope: {
      excluded: formData.sliceId ? [ formData.sliceId ] : [],
      rootPath: ['ROOT_ID'],
    },
    type: NativeFilterType.NATIVE_FILTER,
    description: '',
    // adhoc_filters: formInputs.adhoc_filters,
    // time_range: formInputs.time_range,
    // granularity_sqla: formInputs.granularity_sqla,
    // sortMetric: formInputs.sortMetric,
  };
}

function getNewDataMask (oldDataMask: DataMask, columnName: string, value: any): DataMask {
  const filters: QueryObjectFilterClause[] = [];
  const filterState: {label: string, value: any[]} = { label: '', value: [] };
  // if (oldDataMask.extraFormData?.filters?.length === 1
  //     && oldDataMask.extraFormData.filters[0].col === columnName
  //     && oldDataMask.extraFormData.filters[0].op === 'IN') {
      // single filter_select set from chart
      // filter for columnName exists
      // const newValues = oldDataMask.extraFormData.filters[0].val.indexOf(value) > -1 ?
      //   // if filter with value exists
      //   [...oldDataMask.extraFormData.filters[0].val.filter(val => val !== value)]
      //   // if filter with value does not exist
      //   : [...oldDataMask.extraFormData.filters[0].val, value];
      // if (newValues.length > 0) {
      //   filters.push({
      //     col: columnName,
      //     op: 'IN',
      //     val: newValues
      //   });
      //   filterState.label = newValues.join(',');
      //   filterState.value = newValues;
      // }
  // } else {
  //   // not set from chart (not a single select filter for columnName)
  //   filters.push({
  //     col: columnName,
  //     op: 'IN',
  //     val: [value]
  //   });
  //   filterState.label = `${value}`;
  //   filterState.value = [value];
  // }
  filters.push({
    col: columnName,
    op: 'IN',
    val: [value]
  });
  filterState.label = `${value}`;
  filterState.value = [value];
  const newDataMask: DataMask = {
    extraFormData: filters.length === 0 ? {} : {
      filters
    },
    filterState: filters.length === 0 ? {value: []} : filterState
  };
  return newDataMask;
}

export async function addFilterToDashboard (
  formData: QueryFormData,
  dashboardFilterConfig: FilterConfiguration,
  dashboardDataMask: DataMaskStateWithId,
  value: any,
  dispatch: Dispatch<any>) {
  try {
    // console.log(value);     
    // console.log(params.name);
    if (!formData.groupby) {
      throw new Error('Unexpected Error: Undefined Column name!');
    }
    const columnName = getColumnLabel(Array.isArray(formData.groupby) ? formData.groupby[0] : formData.groupby);
    // console.log(columnName);
    // console.log(formData);

    if (formData.datasource.indexOf('__table') === -1) {
      throw new Error('Datasource not a dataset!');
    }

    const filterIdSuffix = `_chart_${formData.sliceId}`;
    // const dashboardTempFilterConfig = useTempFilterConfiguration();
    
    const filterIndex = dashboardFilterConfig.findIndex(filter => filter.id.indexOf(filterIdSuffix) > -1);
    
    // console.log('filterIndex');
    // console.log(filterIndex);
    // console.log(dashboardDataMask)
    // console.log(filterIndex)
    // console.log(dashboardDataMask[dashboardFilterConfig[filterIndex].id])
    if (filterIndex > -1) {
      const newDataMask = getNewDataMask(dashboardFilterConfig[filterIndex].defaultDataMask || {},
        columnName, value);
      // console.log('newDataMask');
      // console.log(newDataMask);
      //Set data to state variable
      dispatch(await updateTempFilter(dashboardFilterConfig[filterIndex].id, newDataMask,formData.sliceId,formData.datasource));
      // dispatch(updateDataMask(dashboardFilterConfig[filterIndex].id, newDataMask));
    } else {
      const newFilterConfig: FilterConfiguration = [
        ...dashboardFilterConfig,
        getFilterConfig(formData,
          generateFilterId(NativeFilterType.NATIVE_FILTER) + filterIdSuffix,
          columnName,
          value)
      ];
      // console.log('newFilterConfig'); 
      // console.log(newFilterConfig);    
      //Set data to state variable
      
      dispatch(await setTempFilter(newFilterConfig,formData.sliceId,formData.datasource));
      // dispatch(await setFilterConfiguration(newFilterConfig));
    }

  } catch (ex) {
    console.log(ex);
  }
}

export function getLegendObject(show: boolean, orientation: LegendOrientation, margin?: string) {
  let top = '';
  let left: string | null = null;
  let right: string | null = null;
  if (orientation === LegendOrientation.Left || orientation === LegendOrientation.Right) {
    top = 'center';
    left = orientation === LegendOrientation.Left ? margin || '0' : null;
    right = orientation === LegendOrientation.Right ? margin || '0' : null;
  }
  else {
    top = orientation === LegendOrientation.Top ? margin || 'top' : 'bottom';
    left = 'center';
  }
  return {
    show,
    top,
    ...(left && {left}),
    ...(right && {right}),
    orient: orientation === LegendOrientation.Left || orientation === LegendOrientation.Right ?
      'vertical' : 'horizontal',
    type: 'scroll'
  }
}

export function getSortOptions() {
  return [
    [ AxisLabelSortOrder.None, 'None' ],
    [ AxisLabelSortOrder.Asc, 'Ascending Order' ],
    [ AxisLabelSortOrder.Desc, 'Descending Order' ]
  ];
}

export function sortKeys(keys: string[], sortType: AxisLabelSortOrder) {
  try {
    if (sortType === AxisLabelSortOrder.Asc) {
      keys.sort((a, b) => a.localeCompare(b)).reverse();
    }
    if (sortType === AxisLabelSortOrder.Desc) {
      keys.sort((a, b) => a.localeCompare(b));
    }
  } catch (ex) {
    console.log(ex);
  }
}

// export function getFormattedKeys(keys: string[], format: string): string[] {
//   if (format === NumberFormats.ORIGINAL) {
//     return keys;
//   }
//   try {
//     const formatter = getNumberFormatter(format);
//     return keys.map(parseInt).map(formatter);
//   } catch (ex) {
//     console.log(ex);
//     return keys;
//   }
// }
